import { render, staticRenderFns } from "./betterScroll.vue?vue&type=template&id=feba8bba&scoped=true"
import script from "./betterScroll.vue?vue&type=script&lang=js"
export * from "./betterScroll.vue?vue&type=script&lang=js"
import style0 from "./betterScroll.vue?vue&type=style&index=0&id=feba8bba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feba8bba",
  null
  
)

export default component.exports